<template>
  <div>
    <div class="mobile-header d-flex d-md-none row">
      <button ref="toggleNavRef" class="btn btn-tertiary__slim d-flex" @click="toggleNav">
        <svg-icon
          icon="menu"
          width="18px"
          height="18px"
          fill-color="#174776"
          stroke-color="none"
          classes="text-right"
        />
      </button>
      <h1 class="pt-2">
        {{ title }}
      </h1>
    </div>
    <nav
      id="nav-drawer"
      v-closable="{
        exclude: ['toggleNavRef'],
        handler: 'onClose'
      }"
      class="nav-drawer d-none d-md-flex pt-4 pt-md-0"
    >
      <a href="/" :title="title">
        <h2 class="p-3 d-block d-sm-none d-lg-block">{{ title }}</h2>
        <svg-icon
          icon="home"
          fill-color="#174776"
          stroke-color="none"
          classes="p-2 d-none d-sm-block d-lg-none"
        />
      </a>
      <ul v-if="user.id" class="nav-user mb-2">
        <hr />
        <li class="nav-li has-submenu row">
          <svg-icon icon="admin" fill-color="#174776" stroke-color="none" />
          <a href="/admin" title="Edit" class="d-flex d-sm-none d-lg-flex flex-column justify-content-center"><span class="text-uppercase pl-2">{{ user.username }}</span></a>
          <div class="subnav p-2">
            <h2 class="mt-0 pb-1">
              {{ user.username }}
            </h2>
            <div class="row">
              <div v-if="user.role === 'admin'" class="col-6 pl-0 border-right">
                <h3>Admin</h3>
                <ul>
                  <li class="subnav-li">
                    <a href="/admin/users" title="Primary" class="btn btn-tertiary__icon d-flex">
                      <svg-icon
                        icon="admin"
                        classes="pt-0 pb-0 pl-1 pr-1"
                        fill-color="#174776"
                        stroke-color="none"
                      />
                      <span class="btn-tertiary__text">Users</span>
                    </a>
                  </li>
                  <li class="subnav-li">
                    <a href="/admin/activities" title="Primary" class="btn btn-tertiary__icon d-flex">
                      <svg-icon
                        icon="dash"
                        classes="pt-0 pb-0 pl-1 pr-1"
                        fill-color="#174776"
                        stroke-color="none"
                      />
                      <span class="btn-tertiary__text">Activities</span>
                    </a>
                  </li>
                  <li class="subnav-li">
                    <a href="/admin/challenges" title="Primary" class="btn btn-tertiary__icon d-flex">
                      <svg-icon
                        icon="dash"
                        classes="pt-0 pb-0 pl-1 pr-1"
                        fill-color="#174776"
                        stroke-color="none"
                      />
                      <span class="btn-tertiary__text">Challenges</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-6 pr-0">
                <h3>Account</h3>
                <ul>
                  <li class="subnav-li">
                    <a href="/users/edit" title="Home" class="btn btn-tertiary__icon d-flex">
                      <svg-icon
                        icon="account"
                        classes="pt-0 pb-0 pl-1 pr-1"
                        fill-color="#174776"
                        stroke-color="none"
                      />
                      <span class="btn-tertiary__text">Account</span>
                    </a>
                  </li>
                  <li class="subnav-li">
                    <a
                      href="/users/sign_out"
                      title="Home"
                      data-method="delete"
                      class="btn btn-tertiary__icon d-flex"
                    >
                      <svg-icon
                        icon="logout"
                        classes="pt-0 pb-0 pl-1 pr-1"
                        fill-color="#174776"
                        stroke-color="none"
                      />
                      <span class="btn-tertiary__text">Logout</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <hr />
      </ul>
      <ul class="nav-ul mb-2">
        <li class="nav-li row">
          <a :href="'/challenges'" title="Challenges" class="w-100">
            <svg-icon
              icon="dash"
              classes="pb-0 pl-1 pr-1"
              fill-color="#174776"
              stroke-color="none"
            />
            <span class="nav-li__text">Challenges</span>
          </a>
        </li>
        <li class="nav-li row">
          <a :href="'/'" title="My progress" class="w-100">
            <svg-icon
              icon="face"
              classes="pb-0 pl-1 pr-1"
              fill-color="#174776"
              stroke-color="none"
            />
            <span class="nav-li__text">My progress</span>
          </a>
        </li>
        <li
          v-for="(page, index) in pages"
          :key="index"
          class="nav-li row"
        >
          <a :href="'/' + page.slug" :title="page.title" class="w-100">
            <svg-icon
              v-if="page.icon === ''"
              icon="page"
              classes="pt-0 pb-0 pl-1 pr-1"
              fill-color="#174776"
              stroke-color="none"
            />
            <svg-icon
              v-else
              :icon="page.icon"
              classes="pb-0 pl-1 pr-1"
              fill-color="#174776"
              stroke-color="none"
            />
            <span class="pt-1 nav-li__text">{{ page.title }}</span>
          </a>
        </li>
      </ul>
      <span class="spacer"></span>
      <ul class="nav-ul mb-2">
        <li v-if="!user.id" class="nav-li row">
          <a href="/users/sign_in" class="w-100">
            <svg-icon
              icon="enter"
              classes="pb-0 pl-1 pr-1"
              fill-color="#174776"
              stroke-color="none"
            />
            <span class="pt-1 nav-li__text">Login</span>
          </a>
        </li>
        <li v-else class="nav-li row">
          <a
            id="sync-btn"
            href="/update-activities"
            class="w-100"
            data-remote="true"
            @click="isClicked = true"
          >
            <span :class="['p-0', { spinning: isClicked }]" width="30" height="30">
              <svg-icon
                icon="sync"
                classes="pb-0 pl-1 pr-1"
                fill-color="#174776"
                stroke-color="none"
                width="30px"
                height="30px"
              />
            </span>
            <span class="nav-li__text">Sync Activities</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import SvgIcon from './svg-icon.vue';
import { Closable as vClosable } from '../directives/closable.js';

defineProps({
  pages: {
    type: Array,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});

const isClicked = ref(false);
const toggleNavRef = ref(null);

onMounted(() => {
  const syncBtn = document.getElementById('sync-btn');
  if (syncBtn) {
    syncBtn.addEventListener('ajax:success', () => {
      location.reload();
    });
  }
});

function toggleNav() {
  const nav = document.getElementById('nav-drawer');
  if (nav.classList.contains('d-none')) {
    nav.classList.remove('d-none');
  } else {
    nav.classList.add('d-none');
  }
}

function onClose() {
  const nav = document.getElementById('nav-drawer');
  nav.classList.add('d-none');
}

// Expose onClose for the directive
defineExpose({ onClose });
</script>

<style lang="scss" scoped>
.spinning {
  animation-name: spin;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
</style>
